<template>
    <div class="item">
        <div class="title">
            不同生长期作物数据
            <span>(单位：株)</span>
        </div>
        <div class="search">
            <!-- <div class="crop">
                <el-select v-model="crop" placeholder="请选择" >
                    <el-option
                        v-for="item in cropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="date">
                <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </div>
            <div class="searchText">
                <i class="el-icon-search">查询</i>
            </div> -->
        </div>
        <div class="echarts">
            <div class="data" v-for="(item,index) in dataList" :key="index">
                <el-progress type="circle" text-color="#fff" :format="format" :percentage="item.cropNum" :width="62" color="#81B337"></el-progress>
                <p>{{ item.grwothName }}</p>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getQX_cropGrowth } from '../../api/api';
  
  
export default {
    data () {
      return {
        date:"",
        // 作物选择列表
        crop:"",
        cropList:[
            {value: '选项1', label: '请选择作物'},
            {value: '选项2', label: '玉米'},
            {value: '选项3', label: '小麦'},
            {value: '选项4', label: '大豆'},
            {value: '选项5', label: '高粱'},
        ],
        // 生长期进度列表
        dataList:[],
        //  查询参数
        query:{
            projectId:"1622845821245853697",
            cropId:"",
            startTime:"",
            endTime:"",
        }
      }
    },
    created () { 
        this.projectId = JSON.parse(localStorage.getItem("projectId"))
        if(this.projectId ){
            this.getData(this.projectId)
        }
    },
    mounted () { 
       
        let _this = this
        window.addEventListener('setItemEvent', function(e) {
            const newdata = JSON.parse(e.newValue)
            console.log('值改变了',newdata)
            _this.getData(newdata)
        })
    },
    methods: {
        // 获取数据
        async getData(projectId){
            this.query.projectId = projectId
            let res = await getQX_cropGrowth({
                ...this.query
            })
            console.log(res,"不同时期生长物数据");
            if(res.code == 200){
                if(res.data){
                    // this.dataList.push(res.data)
                    this.dataList = res.data
                    console.log(this.dataList);
                }
            }
        },


        // 格式进度条文字，去掉%号
        format(percentage) {
            // console.log(percentage);
            return `${percentage}`;
        }
      
    },
    
}
</script>

<style lang="scss" scoped>
.item{
    padding: 16px ;
    background-color: rgba(0, 0, 0, 0.5);
    font-family: SourceHanSansSC-regular;
    width: 565px;
    .title{
        font-size: 20px;
        font-weight: bold;
        line-height: 30px;
        margin-bottom: 10px;
        span{
            font-size: 14px;
            margin-left: 15px;
        }
    }
    .search{
        display: flex;
        align-items: center;
        .crop{
            ::v-deep.el-input{
                width: 120px ;
            }
        }
        .date{
            margin-left: 20px;
            .el-range-editor.el-input__inner{
                width: 300px;
            }
            ::v-deep.el-date-editor .el-range-separator{
                width: 10%;
            }
        }
        .searchText{
            margin-left: 15px;
            i{
                font-size: 24px;
            }
        }
    }
    .echarts{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 10px 90px;
        .data{
            text-align: center;
            margin-right: 50px;
            margin-bottom: 5px;
            ::v-deep .el-progress__text{
                font-size: 20px !important;
            }
        }
    }
}

  
</style>
  